import Axios from "axios";
import {AppContext} from "../AppContext";
import User from "../domain/User";

class AuthService {

    constructor(public appContext: AppContext) {
        //
    }

    public getLoggedInUser(): Promise<User> {
        return Axios.get("/logged-in-user")
            .then((data) => {
                return User.fromPOJO(data.data);
            });
    }

    public logout() {
        return Axios.get("/logout").then(() => {
            this.appContext.user = undefined;
        });
    }

    public changePassword(currentPassword: string | undefined, password: string): Promise<void> {
        return Axios.put(`/profile/change-password`, {currentPassword, password});
    }

}

export default AuthService;
